import SessionEventProto from "../session-event-proto";
import {EntityType} from "../../gd/const/item";

type Header = {
    dataStorageId   : ID
    data            : any
}

export default class SessionDataStorageDelta extends SessionEventProto {

    private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)

        this.header     = {
            dataStorageId   : sessionEvent.id,
            data            : sessionEvent.data.data
        }
    }

    process() {

        if (this.fromSID === gd.sessionId) {
            return false;
        }

        if (this.isDifferentCompany()) return false;

        gd.modelBus.newUpdate(EntityType.DATA_STORAGE, this.method, this.header.dataStorageId, this.header.data, this.header);
    }
};
